import { Link } from 'react-router-dom';
import { Article } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  const category = categories.find((c) => c.slug === article.category);

  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={article.imageUrl}
          alt={article.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          title={article.title}
        />
        {category && (
          <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-xs font-medium text-foreground-700 whitespace-nowrap">
            <i className={`${category.icon} mr-1`}></i>
            {category.name}
          </span>
        )}
      </div>

      <div className="p-4 md:p-5">
        <h3 className="text-base font-heading font-bold text-foreground-900 leading-snug mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {article.date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.readTime} 分钟阅读
          </span>
        </div>
      </div>
    </Link>
  );
}